<template>
  <section class="c-step c-step--certificate">
    <ModalReview :user="user" :course="courseId" @fill-rating-star="fillRatingStar"></ModalReview>

    <section
      class="c-certificate-container overflow-hidden position-relative"
      :class="{full : !isSpecialitation}"
    >
      <section class="py-4 py-lg-5">
        <div ref="workspace" class="container">
          <div class="row justify-content-center white mb-5">
            <div class="col col-12 col-md-9 col-lg-7 col-xl-5">
              <h2 class="fs-21 w-bold text-center">¡Felicitaciones!</h2>
              <p v-if="isFilledSpecialitation" class="mb-0 text-center">
                Has superado todos los cursos de la especialidad,
                <span>¡Comparte tu logro con tus amigos!</span>
              </p>
              <p v-else class="mb-0 text-center">
                Has superado con éxito el examen de: <span class="w-bold">{{course.title}}</span>,
                <span>¡Comparte tu logro con tus amigos!</span>
              </p>

              <div class="mt-4">
                <div class="c-social-media c-social-media--white d-flex justify-content-center">
                  <a
                    :href="getSocialMediaShare('facebook')"
                    class="c-social-media__social c-social-media__social--facebook mx-1"
                    target="_blank"
                  >
                    <i class="icon-facebook d-flex align-items-center fs-18"></i>
                  </a>
                  <a
                    :href="getSocialMediaShare('twitter')"
                    class="c-social-media__social c-social-media__social--twitter mx-1"
                    target="_blank"
                  >
                    <i class="icon-twitter d-flex align-items-center fs-18"></i>
                  </a>
                  <a
                    :href="getSocialMediaShare('linkedin')"
                    class="c-social-media__social c-social-media__social--linkedin mx-1"
                    target="_blank"
                  >
                    <i class="icon-linkedin d-flex align-items-center fs-18"></i>
                  </a>
                  <a
                    :href="getSocialMediaShare('whatsapp')"
                    class="c-social-media__social c-social-media__social--whatsapp mx-1"
                    target="_blank"
                  >
                    <i class="icon-whatsapp d-flex align-items-center fs-18"></i>
                  </a>
                  <CopyToClipboard :certificate="certificateId" class="ms-2" />
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col col-12 col-md-9 col-lg-7 col-xl-7">
              <div class="c-certificate mb-5">
                <figure class="c-certificate-container__vector c-certificate-container__vector--1">
                  <img
                    class="w-100 of--contain" src="../../assets/images/icons/exam/book.svg" alt=""
                  />
                </figure>
                <figure class="c-certificate-container__vector c-certificate-container__vector--2">
                  <img
                    class="w-100 of--contain" src="../../assets/images/icons/exam/ruler.svg" alt=""
                  />
                </figure>
                <figure class="c-certificate-container__vector c-certificate-container__vector--3">
                  <img
                    class="w-100 of--contain" src="../../assets/images/icons/exam/pen.svg" alt=""
                  />
                </figure>
                <figure class="c-certificate-container__vector c-certificate-container__vector--4">
                  <img
                    class="w-100 of--contain" src="../../assets/images/icons/exam/book.svg" alt=""
                  />
                </figure>
                <figure class="c-certificate-container__vector c-certificate-container__vector--5">
                  <img
                    class="w-100 of--contain" src="../../assets/images/icons/exam/ruler.svg" alt=""
                  />
                </figure>
                <figure class="c-certificate-container__vector c-certificate-container__vector--6">
                  <img
                    class="w-100 of--contain" src="../../assets/images/icons/exam/pen.svg" alt=""
                  />
                </figure>

                <figure class="c-certificate__body">
                  <figure class="c-certificate__dots c-certificate__dots--left">
                    <img src="../../assets/images/exam/dots.svg" alt="">
                  </figure>
                  <figure class="c-certificate__dots c-certificate__dots--right">
                    <img src="../../assets/images/exam/dots.svg" alt="">
                  </figure>

                  <img class="h-100 of--contain" :src="getCertificateFile('img')" alt="">
                </figure>

                <div class="c-certificate__download d-flex justify-content-center">
                  <a
                    :href="getCertificateFile('pdf')"
                    class="c-button c-button--third rounded d-flex align-items-center"
                    :download="getCertificateFile('pdf')"
                    target="_blank"
                  >
                    <i class="iconf-download d-flex align-items-center me-2"></i>
                    Descargar certificado
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <canvas id="canvas" class="c-confeti"></canvas>
    </section>
    <section v-if="isSpecialitation" class="bg-white">
      <div class="container">
        <section class="py-4 py-lg-5">
          <div class="row justify-content-center mb-5">
            <div v-if="isFilledSpecialitation" class="col col-12 col-md-9 col-lg-7">
              <h2 class="fs-21 w-bold darks text-center">Cursos de la especialidad</h2>
            </div>
            <div v-else class="col col-12 col-md-9 col-lg-7">
              <h2 class="fs-21 w-bold darks text-center">¡No te detengas!</h2>
              <p class="mb-0 text-center">
                Recuerda que cuando finalices todos los cursos de la especialidad a la
                que pertenece estecurso te enviamos un diploma de certificación por todo el paquete.
              </p>
            </div>
          </div>
          <div class="row justify-content-center">
            <div
              v-for="(course, cindex) of examSettings.specialization_courses.courses"
              :key="course.id"
              class="col col-12 col-md-6 col-lg-4 col-xl-3 mb-4"
            >
              <article
                class="c-card-certificate h-100"
                :class="{'c-card-certificate--uncompleted' : !course.certificate}">
                <div class="position-relative">
                  <p class="c-card-certificate__order mb-0">{{cindex + 1}}</p>
                  <figure class="c-card-certificate__image">
                    <img class="w-100 h-100 of--cover" :src="course.image" alt="">
                  </figure>
                  <div v-if="course.certificate" class="c-sticker position-absolute">
                    <i class="c-icon iconf-medal d-flex align-items-center"></i>
                  </div>
                </div>
                <div class="c-card-certificate__body p-3 p-lg-4">
                  <h3
                    class="c-card-certificate__title fs-18 w-sbold mb-4"
                    :class="{'mt-1' : course.certificate}"
                  >
                    {{course.title}}
                  </h3>
                  <a
                    v-if="course.certificate"
                    :href="getCourseLink(course)"
                    target="_blank"
                    class="c-button c-button--white d-flex
                      justify-content-center align-items-center w-100"
                    download>
                    <i class="me-2 d-flex align-items-center" :class="getIcon(course.certificate)"/>
                    Descargar
                  </a>
                  <a
                    v-else
                    :href="getCourseLink(course)"
                    class="c-button c-button--primary-ghost d-flex
                      justify-content-center align-items-center w-100"
                  >
                    <i class="me-2 d-flex align-items-center" :class="getIcon(course.certificate)"/>
                    Reproducir curso
                  </a>
                </div>
              </article>
            </div>
          </div>
        </section>
      </div>
    </section>
  </section>
</template>

<script>
/* eslint-disable */
import ModalReview from '../../components/lection/modals/ModalReview.vue';

export default {
  data() {
    return {
      ratingStatus: false,
      confettiPromise: null,
      confettiSpace: null,
    }
  },
  props: ['user', 'course', 'exam', 'examSettings'],
  computed: {
    courseId: function() {
      return this.$route.params.course_id;
    },
    isSpecialitation: function() {
      if ('courses' in this.examSettings.specialization_courses) {
        return true;
      } else {
        return false;
      }
    },
    isFilledSpecialitation: function() {
      if ('courses' in this.examSettings.specialization_courses) {
        return (this.examSettings.specialization_courses.spezialization.certificate) ? true : false;
      } else {
        return false;
      }
    },
    certificateId() {
      let file;

      if (('courses' in this.examSettings.specialization_courses) && this.examSettings.specialization_courses.spezialization.certificate) {
        file = this.examSettings.specialization_courses.spezialization.certificate.img;
      } else {
        file = this.examSettings.course.certificate.img;
      }

      file = file.split('/certificate/');
      file = file[1].split('.jpg');

      return file[0];
    },
  },
  components: {
    ModalReview,
    CopyToClipboard: () => import(/* webpackChunkName: "clipboard" */'@/components/exam/Clipboard.vue'),
  },
  mounted() {
    document.getElementById('canvas').width = window.innerWidth - 100;
    document.getElementById('canvas').height = window.innerHeight;

    window.setTimeout(() => {
      this.confettiAnimation(Math.floor(Math.random() * 2) + 1);
    }, 100)
  },
  methods: {
    confettiAnimation: function(type = 1) {
      const confetti  = require('canvas-confetti');

      this.confettiSpace = confetti.create(document.getElementById('canvas'), {});

      if (type == 1) {
        this.cleanAnimation(1);

        this.confettiFire(0.25, {
          spread: 26,
          startVelocity: 55,
        });
        this.confettiFire(0.2, {
          spread: 60,
        });
        this.confettiFire(0.35, {
          spread: 100,
          decay: 0.91,
          scalar: 0.8,
        });
        this.confettiFire(0.1, {
          spread: 120,
          startVelocity: 25,
          decay: 0.92,
          scalar: 1.2,
        });
        this.confettiFire(0.1, {
          spread: 120,
          startVelocity: 45,
        });
      } else {
        this.cleanAnimation(2);
        this.confettiFireworks();
      }
    },
    confettiFire: function(particleRatio, opts) {
      let count     = 200;
      let defaults  = {
        origin: {
          y: 0.7,
        },
      };

      this.confettiSpace(Object.assign({}, defaults, opts, {
        particleCount: Math.floor(count * particleRatio),
      }));
    },
    confettiFireworks: function() {
      let duration      = 2 * 1000;
      let animationEnd  = Date.now() + duration;
      let defaults      = {
        startVelocity: 30,
        spread: 360,
        ticks: 60,
        zIndex: 0,
      };

      function randomInRange(min, max) {
        return Math.random() * (max - min) + min;
      }

      var interval = setInterval(() => {
        var timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
          return clearInterval(interval);
        }

        let particleCount = 50 * (timeLeft / duration);

        this.confettiSpace(Object.assign({}, defaults, { particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } }));
        this.confettiSpace(Object.assign({}, defaults, { particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } }));
      }, 250);
    },
    cleanAnimation: function(type) {
      window.setTimeout(() => {
        document.getElementById('canvas').remove();
      }, (type == 1) ? 4000 : 3100)
    },
    getIcon: function(isCompleted) {
      return (isCompleted) ? 'iconf-download' : 'iconf-play';
    },
    getButtonClass: function(isCompleted) {
      return (isCompleted) ? 'c-button--white' : 'c-button--primary-ghost';
    },
    getCourseLink: function(course) {
      const url = course.url.split('/curso/');

      return (course.certificate) ? course.certificate.pdf : `${url[0]}/curso/${this.$route.params.speciality_id}/${url[1]}`;
    },
    getCertificateFile: function(media) {
      if (('courses' in this.examSettings.specialization_courses) && this.examSettings.specialization_courses.spezialization.certificate) {
        if (media == 'img') {
          return this.examSettings.specialization_courses.spezialization.certificate.img;
        } else {
          return this.examSettings.specialization_courses.spezialization.certificate.pdf;
        }
      } else {
        if (media == 'img') {
          return this.examSettings.course.certificate.img;
        } else {
          return this.examSettings.course.certificate.pdf;
        }
      }
    },
    getSocialMediaShare: function(social) {
      let baseSocial = '';

      switch (social) {
        case 'facebook':
          baseSocial = 'https://www.facebook.com/sharer/sharer.php?u=';
          break;

        case 'twitter':
          baseSocial = 'https://twitter.com/share?text=Mi nuevo logro conseguido gracias a @Arcux...&url=';
          break;

        case 'linkedin':
          baseSocial = 'https://www.linkedin.com/sharing/share-offsite/?url=';
          break;

        case 'whatsapp':
          baseSocial = 'https://api.whatsapp.com/send?text=Mi%20nuevo%20logro%20conseguido%20gracias%20a%20@Arcux..., ';
          break;
      }

      return `${baseSocial}${process.env.VUE_APP_SITE}/panel/certificados/${this.certificateId}`;
    },
    getRating: function() {
      const requestURL = `${window.arcux.site}/api/v1/users/${this.user.id}/ratings/?courseId=${this.$route.params.course_id}`;

      fetch(requestURL)
      .then(res => {
        if (res.status == 201 || res.status < 300) {
          this.fillRatingStar();
        } else {
          throw res;
        }
      })
      .catch(err => {
        throw err;
      })
    },
    fillRatingStar: function() {
      this.ratingStatus = true;
    },
  },
}
</script>
